import script from "./TableItemEventEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableItemEventEditor.vue?vue&type=script&lang=ts&setup=true"

import "./TableItemEventEditor.vue?vue&type=style&index=0&id=401518b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-401518b5"]])

export default __exports__